import React from 'react'

/**
 * Orientação paisagem por seção — confirmado por inspeção do PDF-modelo real ("Modelo
 * PGR 2026 - Banco Bradesco_Varejo"): as páginas 42-51 (Seção 18, Inventário de Riscos)
 * e 52-54 (Seção 19, Plano de Ação/cronograma de 36 meses) usam página A4 paisagem
 * (842x596pt, larguraxaltura invertida vs. as demais páginas do documento, 596x842pt) —
 * confirmado via `pdfinfo -f <página> -l <página>` sobre cada página do PDF-modelo, não
 * presumido. As demais seções continuam retrato.
 *
 * Este documento é gerado via impressão do navegador para PDF (ver ADR-0007) — sem uma
 * API real de paginação, a única forma de ter ORIENTAÇÃO MISTA (a maioria retrato, duas
 * seções paisagem) num único documento impresso, sem tocar em `components/pdf/` nem em
 * `printPdf.js` (compartilhados com outras marcas), é via CSS Paged Media "named pages"
 * (`@page <nome> { size: landscape }` + propriedade `page: <nome>` no elemento) — o
 * mesmo mecanismo de CSS Paged Media que `Footer.js` já usa para o contador de página
 * (`@page { @bottom-right { content: counter(page) } }`), copiado para o PDF pelo
 * print-js porque o `<style>` fica dentro da própria árvore de `#pdfPage`.
 *
 * Por especificação, o valor usado de `page` numa caixa sem declaração própria é herdado
 * do ANCESTRAL mais próximo que declara um nome (não do irmão anterior) — então a seção
 * seguinte (20, retrato) volta automaticamente ao contexto de página padrão sem precisar
 * de nenhum "reset" explícito aqui, e o conteúdo aninhado dentro da Seção 18/19 (uma
 * `View` por GHE/cargo, cada uma com seu próprio `pageBreakAfter`) herda a paisagem por
 * ser descendente da `View` que declara `page`.
 *
 * Igual ao contador de página do rodapé, este é um recurso avançado do motor de
 * impressão do Chromium — não foi possível validar visualmente neste ambiente (sem
 * navegador para imprimir/gerar o PDF real). Ver observação no PR.
 */
export const LANDSCAPE_PAGE_NAME = 'bradescoPgrPaisagem'

export const LANDSCAPE_PAGE_STYLE = { page: LANDSCAPE_PAGE_NAME }

// `<style>` com a página nomeada em si — só precisa aparecer uma vez em qualquer lugar
// da árvore de `#pdfPage`; cada seção paisagem inclui a sua própria (custo desprezível,
// evita uma dependência de ordem de import entre as duas seções que a usam).
export const LandscapePageDefinition = () => (
  <style>{`
    @page ${LANDSCAPE_PAGE_NAME} {
      size: landscape;
    }
  `}</style>
)
